import { enumToArray } from '@libs/types/src/common/enum/util';

export enum ContactTypeEnum {
    contact = 'contact',
    authorized = 'authorized',
    doctor = 'doctor',
}

export const contactTypes = enumToArray(ContactTypeEnum);
